module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarX-1.dc27cb98.png";